const uploadFormats = {
    images: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'],
    documents: [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'text/plain',
    ],
    videos: ['video/mp4', 'video/webm', 'video/ogg', 'video/x-matroska', 'video/quicktime'],
    audio: ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/aac'],
    archives: [
        'application/zip',
        'application/x-7z-compressed',
        'application/x-rar-compressed',
        'application/x-tar',
        'application/gzip',
    ],
};

// Flatten the array if needed for use
export const allUploadFormats = [
    ...uploadFormats.images,
    ...uploadFormats.documents,
    ...uploadFormats.videos,
    ...uploadFormats.audio,
    ...uploadFormats.archives,
];

export const pdfOnly = [uploadFormats.documents[0]];
export const audioOnly = [...uploadFormats.audio];

export const extensionToMimeType = (extensions?: string[]) => {
    if (!extensions) return undefined;
    const extensionMap: Record<string, string> = {
        '.jpeg': 'image/jpeg',
        '.jpg': 'image/jpeg',
        '.png': 'image/png',
        '.gif': 'image/gif',
        '.webp': 'image/webp',
        '.svg': 'image/svg+xml',
        '.pdf': 'application/pdf',
        '.doc': 'application/msword',
        '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.xls': 'application/vnd.ms-excel',
        '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.txt': 'text/plain',
        '.mp4': 'video/mp4',
        '.webm': 'video/webm',
        '.ogg': 'video/ogg',
        '.mkv': 'video/x-matroska',
        '.mov': 'video/quicktime',
        '.mp3': 'audio/mpeg',
        '.wav': 'audio/wav',
        '.aac': 'audio/aac',
        '.zip': 'application/zip',
        '.7z': 'application/x-7z-compressed',
        '.rar': 'application/x-rar-compressed',
        '.tar': 'application/x-tar',
        '.gz': 'application/gzip',
    };

    return extensions.map(ext => extensionMap[ext]).filter(mimeType => mimeType !== null);
};
